export interface NavItem {
  label: string;
  to: string;
}

export const SITE = {
  name: '瓜田观察',
  shortName: '瓜田',
  latinName: 'GUATIAN OBSERVER',
  tagline: '热点热议 · 讨论区实时更新',
  slogan: '看当事人怎么说，也看网友怎么评',
  description:
    '瓜田观察是一个围绕网络热点与娱乐讨论的中文内容社区，为你梳理事件脉络、各方说法与讨论区实时动态，看当事人怎么说、网友怎么评，理性吃瓜一站搞定。',
  email: 'contact@guatian-observer.com',
  since: '2021',
  nav: [
    { label: '首页', to: '/' },
    { label: '话题广场', to: '/topics' },
    { label: '关于我们', to: '/about' },
    { label: '常见问题', to: '/faq' },
    { label: '联系我们', to: '/contact' },
  ] as NavItem[],
  footerGroups: [
    {
      title: '逛话题',
      links: [
        { label: '今日热榜', to: '/' },
        { label: '话题广场', to: '/topics' },
        { label: '综艺现场', to: '/topics?category=variety' },
        { label: '影视剧集', to: '/topics?category=drama' },
      ] as NavItem[],
    },
    {
      title: '了解我们',
      links: [
        { label: '关于我们', to: '/about' },
        { label: '内容原则', to: '/about' },
        { label: '常见问题', to: '/faq' },
        { label: '联系我们', to: '/contact' },
      ] as NavItem[],
    },
  ],
};

export const FORM_ENDPOINT = 'https://readdy.ai/api/form/dah7fe3p14a1h3mr6e0g';
export const FORM_ID = 'dah7fe3p14a1h3mr6e0g';